import React, { Component } from "react";
import { Route } from "react-router-dom";
import Master from "./Master";
import { LoginProvider } from "./components/Login/LoginProvider";
import Register from "./components/Register/Register";
import Password from "./components/Password/Password";
import * as log from "../src/common/Feedback/Log";
import { browserName, browserVersion, deviceDetect } from "react-device-detect";

class Hoc extends Component {
  state = {};
  constructor() {
    super();
    this.state = {};
    this.setBrowserInformation();
  }

  render() {
    log.info(localStorage);
    const validEmail = localStorage.getItem("email");
    if (validEmail) {
      return <Master />;
    } else {
      return (
        <div>
          <Route path="/" exact component={LoginProvider} />
          <Route path="/register" exact component={Register} />
          <Route path="/password" exact component={Password} />
        </div>
      );
    }
  }

  setBrowserInformation = () => {
    localStorage.setItem("deviceSettings", JSON.stringify(deviceDetect()));
  };
}

export default Hoc;



// WEBPACK FOOTER //
// ./src/Hoc.js